import {
  Box,
  Button,
  MenuItem,
  Paper,
  Select,
  TextField,
} from "@mui/material";
// import axios from "axios";
import React, { useEffect, useState } from "react";
import api from "../../../API";
import { useSelector } from "react-redux";
import _debounce from 'lodash/debounce';
import { KmDataType } from "./KhmListPage";
import { DetailTrans } from "../prc/KhmDetailDialog";

const initailData: KmDataType = {
  idx: -1,
  site_name: "",
  title_km: "",
  url: "",
  text_km: "",
  issue_date: "",
  writer_km: "",
  copyrighter_km: "",
  orgext: "",
  data_type: "",
  topic_km: "",
  keyword_km: "",
  keyword2_km: "",
  worker:"",
  work_date:"",
  work_yn:"",
  prc_date:"",
  prc_yn:"",

  title_ko: "",
  text_ko: "",
  keyword_ko: "",

  title_en: "",
  text_en: "",
  keyword_en: "",
};

const initailDetailData: DetailTrans = {
  idx: -1,
  crw_idx: -1,
  title_ko: "",
  text_ko: "",
  title_en: "",
  text_en: "",
  ins_date: "",

};

const KhmDetailDialog = (props: any) => {
  // console.log("props", props);

  const [data, setData] = useState<any>(initailData);

  const [detail, setDetail] = useState<DetailTrans>(initailDetailData);

  const [state, setState] = useState("1")

  const [auths, setAuths] = useState([]);
  
  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  // let manager_role = auth.user.roles.some((obj:any) => ['VIE_MANAGER'].includes(obj.role));

  const getAuths = async () => {
    var result = await api.get("/getAuths");
    setAuths(result.data.data);
  };

  const getDetail = async (idx: number) => {
    var result = await api.get("/km-detail",{params:{idx:idx}});
    console.log('getDetail', result.data.datas[0]);
    setDetail(result.data.datas[0])
  };


  const saveKhmData = async (isp_yn:string) => {

    const formData = new FormData();

    formData.append("email", email);

    formData.append("isp_yn", isp_yn);

    formData.append("datas", JSON.stringify(data));

    await api.post("/km-isp-update",formData)
    .then((res:any) => { alert("업데이트가 완료되었습니다."); props.updateAfter(); })
    .catch((error:any) => {alert('오류 - '+ error.response.data.error);})

  }

  // const openGuideWindow = () => {
  //   const imageUrl = `${process.env.PUBLIC_URL}/img/vie-task/Vie-CSQA.jpg`;

  //   window.open(imageUrl, '_blank');
  // }

  useEffect(() => {
    getAuths();
    setData(props.rowDetail);
    if(props.rowDetail != undefined){
      getDetail(props.rowDetail.idx)
    }
  }, [props.rowDetail]);

  return (
    <Paper sx={{width:"100%", overflow: "auto"}}>
      <Box sx={{margin:"20px 20px 0px 20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>데이터 정보</Box>
      <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
      {data ? <>
        <Box display="flex">
        <Box>
          <Paper sx={{padding:"8px", margin:"4px 16px 16px 16px", border:"3px solid #3e36a5", background: "linear-gradient(to right, #d5f0da 25%, #a3e4ed 75%)"}}>
              <Box sx={{width:"800px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"4px"}}>
                    <Box sx={{fontSize:"22px", fontWeight:700, textAlign:"center", margin:"2px"}}>KM</Box>
                      {/* <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>키워드 (KEYWORD)</Box>
                      <Box><textarea value={data.keyword_km} onChange={(e) => {setData({ ...data, keyword_km: e.target.value });}} spellCheck="false" style={{width:"780px",minHeight:"22px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box> */}

                      <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                      <Box><textarea value={data.title_km} onChange={(e) => {setData({ ...data, title_km: e.target.value });}} spellCheck="false" style={{width:"780px",minHeight:"55px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>

                      <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                      <Box><textarea value={data.text_km} onChange={(e) => {setData({ ...data, text_km: e.target.value });}} spellCheck="false" style={{width:"780px",minHeight:"500px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>

                    </Box>
                  </Box>
                </Box>
              </Box>
          </Paper>
        </Box>

        <Box>
          <Select id="orgext" value={state} onChange={(e) => {setState(e.target.value);}} sx={{color:"green",width:"130px",height: "35px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
            <MenuItem dense value={"1"}>기본정보</MenuItem>
            <MenuItem dense value={"2"}>한글번역</MenuItem>
            <MenuItem dense value={"3"}>영어번역</MenuItem>
          </Select>
          {state === "1" ? 
          <Paper sx={{padding:"20px", margin:"16px",position: "sticky",top: "-16px", zIndex: 1, backgroundColor:"#fff"}} >
          <Box display="flex" sx={{marginLeft: "8px"}}>
            <Box sx={{width:"100%"}}>
              <Box m={2} display="flex" sx={{alignItems:"center"}}>
                <Box sx={{fontSize:"14px",fontWeight:700, width:"112px"}}>IDX</Box>
                <Box sx={{fontSize:"14px", width:"190px"}}>{data.idx}</Box>
              </Box>

              <Box m={2} display="flex" sx={{alignItems:"center"}}>
                <Box sx={{fontSize:"14px",fontWeight:700, width:"112px"}}>작업워커</Box>
                <Box sx={{fontSize:"14px", width:"190px"}}>{data.worker}</Box>
              </Box>

              <Box m={2} display="flex" sx={{alignItems:"center"}}>
                <Box sx={{fontSize:"14px",fontWeight:700, width:"112px"}}>작업상태</Box>

                <Box sx={{fontSize:"14px", marginLeft:"8px", padding: "2px 6px 2px 6px", borderRadius:"4px",
                    backgroundColor: (data.isp_yn === "Y" ? "#27cc2f" : "#bbb"), color:"#fff"
                }}>
                  {(data.isp_yn === "Y" ? "작업완료" : "미작업")}
                </Box>
              </Box>

              <Box m={2} display="flex" sx={{alignItems:"center"}}>
                <Box sx={{fontSize:"14px",fontWeight:700, width:"104px"}}>업데이트시간</Box>
                <Box sx={{fontSize:"14px", width:"190px"}}>{data.prc_date}</Box>
              </Box>

              <Box m={2} display="flex" sx={{alignItems:"center"}}>
                <Box sx={{fontSize:"14px",fontWeight:700, width:"114px"}}>사이트명</Box>
                <Box sx={{fontSize:"14px", width:"500px"}}>
                  <TextField sx={{fontSize:"8px"}} id="site_name" name="site_name" size="small"
                            value={data.site_name} onChange={(e) => {setData({ ...data, site_name: e.target.value });}}
                  // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
                    InputProps={{
                      style: {width: "500px", height:"30px", fontSize:"14px"},
                      inputProps: { 
                        spellCheck: "false" // spellcheck를 false로 설정
                      },
                    }}
                  />
                </Box>
              </Box>

              <Box m={2} display="flex" sx={{alignItems:"center"}}>
                <Box sx={{fontSize:"14px",fontWeight:700, width:"114px"}}>출처 - URL</Box>
                <Box sx={{fontSize:"14px", width:"500px"}}>
                  <TextField sx={{fontSize:"8px"}} id="url" name="url" size="small"
                            value={data.url} onChange={(e) => {setData({ ...data, url: e.target.value });}}
                  // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
                    InputProps={{
                      style: {width: "500px", height:"30px", fontSize:"14px"},
                      inputProps: { 
                        spellCheck: "false" // spellcheck를 false로 설정
                      },
                    }}
                  />
                </Box>
              </Box>
              
              <Box m={2} display="flex" sx={{alignItems:"center"}}>
                <Box sx={{fontSize:"14px",fontWeight:700, width:"112px"}}>발행일자</Box>
                <Box sx={{fontSize:"14px", width:"200px"}}>
                  <TextField sx={{fontSize:"8px"}} id="issue_date" name="issue_date" size="small" type="date"
                            value={data.issue_date} onChange={(e) => {setData({ ...data, issue_date: e.target.value });}}
                  // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
                    InputProps={{
                      style: {width: "200px", height:"30px", fontSize:"14px"},
                      inputProps: { 
                        spellCheck: "false" // spellcheck를 false로 설정
                      },
                    }}
                  />
                </Box>
              </Box>
              <Box display="flex">
                <Box sx={{border:"2px solid #a9a6c9"}}>
                  <Box display="flex" sx={{alignItems: "center", margin:"4px"}}>
                    {/* <img style={{width:"34px", marginLeft:"8px", objectFit: "cover", alignSelf: "center"}} src={process.env.PUBLIC_URL + '/img/km_flag.jpg'} /> */}
                    <Box ml={1} sx={{fontSize:"14px",fontWeight:700, color:"#3e36a5"}}>크메르어(KM)</Box>
                  </Box>
                  <Box display="flex">
                    <Box m={1} display="flex" sx={{alignItems:"center"}}>
                      <Box ml={2} sx={{fontSize:"14px",fontWeight:700, width:"102px"}}>저작자</Box>
                      <Box sx={{fontSize:"14px", width:"200px"}}>
                        <TextField sx={{fontSize:"8px"}} id="writer_km" name="writer_km" size="small"
                                  value={data.writer_km} onChange={(e) => {setData({ ...data, writer_km: e.target.value });}}
                        // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
                          InputProps={{
                            style: {width: "200px", height:"30px", fontSize:"14px"},
                            inputProps: { 
                              spellCheck: "false" // spellcheck를 false로 설정
                            },
                          }}
                        />
                      </Box>
                      <Box ml={2} sx={{fontSize:"14px",fontWeight:700, width:"112px"}}>저작권소유자</Box>
                      <Box sx={{fontSize:"14px", width:"200px"}}>
                        <TextField sx={{fontSize:"8px"}} id="copyrighter_km" name="copyrighter_km" size="small"
                                  value={data.copyrighter_km} onChange={(e) => {setData({ ...data, copyrighter_km: e.target.value });}}
                        // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
                          InputProps={{
                            style: {width: "200px", height:"30px", fontSize:"14px"},
                            inputProps: { 
                              spellCheck: "false" // spellcheck를 false로 설정
                            },
                          }}
                        />
                      </Box>
                    </Box>
                  </Box>

                  <Box m={3} display="flex" sx={{alignItems:"center"}}>
                    <Box sx={{fontSize:"14px",fontWeight:700, width:"102px"}}>키워드</Box>
                    <Box sx={{fontSize:"14px", width:"500px"}}>
                      <TextField sx={{fontSize:"8px"}} id="keyword_km" name="keyword_km" size="small"
                                value={data.keyword_km} onChange={(e) => {setData({ ...data, keyword_km: e.target.value });}}
                      // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
                        InputProps={{
                          style: {width: "500px", height:"30px", fontSize:"14px"},
                          inputProps: { 
                            spellCheck: "false" // spellcheck를 false로 설정
                          },
                        }}
                      />
                    </Box>
                  </Box>

                </Box>
              </Box>
              {/* <Box mt={2} display="flex">
                <Box sx={{border:"2px solid #a9a6c9"}}>
                  <Box display="flex" sx={{alignItems: "center", margin:"4px"}}>
                    <img style={{width:"34px", marginLeft:"8px", objectFit: "cover", alignSelf: "center"}} src={process.env.PUBLIC_URL + '/img/ko_flag.jpg'} />
                    <Box ml={1} sx={{fontSize:"14px",fontWeight:700, color:"#3e36a5"}}>한국어(KO)</Box>
                  </Box>
                  <Box m={1} display="flex" sx={{alignItems:"center"}}>
                    <Box ml={2} sx={{fontSize:"14px",fontWeight:700, width:"102px"}}>저작자</Box>
                    <Box sx={{fontSize:"14px", width:"200px"}}>
                      <TextField sx={{fontSize:"8px"}} id="issue_date" name="issue_date" size="small"
                                value={data.copyrighter_ko} onChange={(e) => {setData({ ...data, copyrighter_km: e.target.value });}}
                      // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
                        InputProps={{
                          style: {width: "200px", height:"30px", fontSize:"14px"},
                          inputProps: { 
                            spellCheck: "false" // spellcheck를 false로 설정
                          },
                        }}
                      />
                    </Box>
                    <Box ml={2} sx={{fontSize:"14px",fontWeight:700, width:"112px"}}>저작자소유자</Box>
                    <Box sx={{fontSize:"14px", width:"200px"}}>
                      <TextField sx={{fontSize:"8px"}} id="issue_date" name="issue_date" size="small"
                                value={data.copyrighter_ko} onChange={(e) => {setData({ ...data, copyrighter_km: e.target.value });}}
                      // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
                        InputProps={{
                          style: {width: "200px", height:"30px", fontSize:"14px"},
                          inputProps: { 
                            spellCheck: "false" // spellcheck를 false로 설정
                          },
                        }}
                      />
                    </Box>
                  </Box>
                </Box>

              </Box> */}

              <Box m={2} display="flex" sx={{alignItems:"center"}}>
                <Box sx={{fontSize:"14px",fontWeight:700, width:"106px"}}>주제분류</Box>
                <Select id="topic_km" value={data.topic_km} onChange={(e) => {setData({ ...data, topic_km: e.target.value });}} sx={{color:"green",width:"440px",height: "35px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                  <MenuItem dense value={"01"}>문화,예술,교육{" "}<b style={{fontFamily: "Khmer OS, serif"}}>&nbsp;(វប្បធម៌,សិល្បៈ,ការអប់រំ)</b></MenuItem>
                  <MenuItem dense value={"02"}>역사,지리,관광 <b style={{fontFamily: "Khmer OS, serif"}}>&nbsp;(ប្រវត្តិសាស្រ្ត,ភូមិសាស្ត្រ,ទេសចរណ៍)</b></MenuItem>
                  <MenuItem dense value={"03"}>스포츠,기타 <b style={{fontFamily: "Khmer OS, serif"}}>&nbsp;(កីឡា,ផ្សេងៗ)</b></MenuItem>
                  <MenuItem dense value={"04"}>사회,산업 <b style={{fontFamily: "Khmer OS, serif"}}>&nbsp;(សង្គម,ឧស្សាហកម្ម)</b></MenuItem>
                  <MenuItem dense value={"05"}>정치,경제 <b style={{fontFamily: "Khmer OS, serif"}}>&nbsp;(នយោបាយ,សេដ្ឋកិច្ច)</b></MenuItem>
                  <MenuItem dense value={"06"}>과학,의학 <b style={{fontFamily: "Khmer OS, serif"}}>&nbsp;(វិទ្យាសាស្ត្រ,វេជ្ជសាស្ត្រ)</b></MenuItem>
                  <MenuItem dense value={"07"}>관습,예절 <b style={{fontFamily: "Khmer OS, serif"}}>&nbsp;(ទំនៀមទម្លាប,ទម្លាប់)</b></MenuItem>
                  <MenuItem dense value={"08"}>일상생활,음식 <b style={{fontFamily: "Khmer OS, serif"}}>&nbsp;(ជីវិតប្រចាំថ្ងៃ,អាហារ)</b></MenuItem>
                </Select>
              </Box>

              {/* <Box m={2} display="flex" sx={{alignItems:"center"}}>
                <Box sx={{fontSize:"14px",fontWeight:700, width:"114px"}}>키워드(KO)</Box>
                <Box sx={{fontSize:"14px", width:"500px"}}>
                  <TextField sx={{fontSize:"8px"}} id="keyword_ko" name="keyword_ko" size="small"
                            value={data.keyword_ko} onChange={(e) => {setData({ ...data, keyword_ko: e.target.value });}}
                  // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
                    InputProps={{
                      style: {width: "500px", height:"30px", fontSize:"14px"},
                      inputProps: { 
                        spellCheck: "false" // spellcheck를 false로 설정
                      },
                    }}
                  />
                </Box>
              </Box> */}

              <Box display="flex">
                <Box m={2} display="flex" sx={{alignItems:"center"}}>
                  <Box sx={{fontSize:"14px",fontWeight:700, width:"106px"}}>파일형태(원본)</Box>
                  <Box sx={{fontSize:"14px", width:"190px"}}>
                    <Select id="orgext" value={data.orgext} onChange={(e) => {setData({ ...data, orgext: e.target.value });}} sx={{color:"green",width:"130px",height: "35px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                      <MenuItem dense value={"01"}>HTML</MenuItem>
                      <MenuItem dense value={"02"}>PDF</MenuItem>
                      <MenuItem dense value={"03"}>IMAGE</MenuItem>
                    </Select>
                  </Box>
                </Box>

                <Box m={2} ml={2} display="flex" sx={{alignItems:"center"}}>
                  <Box sx={{fontSize:"14px",fontWeight:700, width:"102px"}}>자료유형(원본)</Box>
                  <Box sx={{fontSize:"14px", width:"186px"}}>
                  <Select id="data_type" value={data.data_type} onChange={(e) => {setData({ ...data, data_type: e.target.value });}} sx={{color:"green",width:"130px",height: "35px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                    <MenuItem dense value={"01"}>저서</MenuItem>
                    <MenuItem dense value={"02"}>논문</MenuItem>
                    <MenuItem dense value={"03"}>기사</MenuItem>
                    <MenuItem dense value={"04"}>문서</MenuItem>
                    <MenuItem dense value={"05"}>직접작성</MenuItem>
                    <MenuItem dense value={"06"}>기타</MenuItem>
                  </Select>
                  </Box>
                </Box>
              </Box>

                  <Box m={2} display="flex" sx={{alignItems:"center"}}>
                    <Box sx={{fontSize:"14px",fontWeight:700, width:"114px"}}>어절수</Box>
                    <Box sx={{fontSize:"14px", width:"500px"}}>
                      <TextField sx={{fontSize:"8px"}} id="work_cnt" name="work_cnt" size="small"
                                value={data.work_cnt} onChange={(e) => {setData({ ...data, work_cnt: e.target.value });}}
                      // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
                        InputProps={{
                          style: {width: "120px", height:"30px", fontSize:"14px"},
                          inputProps: { 
                            spellCheck: "false" // spellcheck를 false로 설정
                          },
                        }}
                      />
                    </Box>
                  </Box>


                  


                </Box>
              </Box>
          </Paper>
          : (state === "2" ? 
            <Paper sx={{padding:"8px", margin:"16px", border:"3px solid #3e36a5", background: "linear-gradient(to right, #f1c5cd 25%, #aab3ee 75%)"}}>
            <Box sx={{width:"700px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
              <Box sx={{display:"flex", alignItems:"center"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"4px"}}>
                  <Box sx={{fontSize:"22px", fontWeight:700, textAlign:"center", margin:"2px"}}>한글번역(KO)</Box>
                    <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>키워드 (KEYWORD)</Box>
                    <Box><textarea value={data.keyword_ko} onChange={(e) => {setData({ ...data, keyword_ko: e.target.value });}} spellCheck="false" style={{width:"680px",minHeight:"22px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                    {detail && 
                    <>
                    <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                    <Box><textarea value={detail.title_ko} onChange={(e) => {setData({ ...detail, title_ko: e.target.value });}} spellCheck="false" style={{width:"680px",minHeight:"52px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>

                    <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                    <Box><textarea value={detail.text_ko} onChange={(e) => {setData({ ...detail, text_ko: e.target.value });}} spellCheck="false" style={{width:"680px",minHeight:"380px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                    </>
                    }
                  </Box>
                </Box>
              </Box>
            </Box>
        </Paper>
           : 
           <Paper sx={{padding:"8px", margin:"16px", border:"3px solid #3e36a5", background: "linear-gradient(to right, #b6c6f1 25%, #f1d4d9 75%)"}}>
            <Box sx={{width:"700px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
              <Box sx={{display:"flex", alignItems:"center"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"4px"}}>
                  <Box sx={{fontSize:"22px", fontWeight:700, textAlign:"center", margin:"2px"}}>영어번역(EN)</Box>
                    <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>키워드 (KEYWORD)</Box>
                    <Box><textarea value={data.keyword_en} onChange={(e) => {setData({ ...data, keyword_en: e.target.value });}} spellCheck="false" style={{width:"680px",minHeight:"22px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                    {detail && 
                    <>
                    <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                    <Box><textarea value={detail.title_en} onChange={(e) => {setData({ ...detail, title_en: e.target.value });}} spellCheck="false" style={{width:"680px",minHeight:"52px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>

                    <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                    <Box><textarea value={detail.text_en} onChange={(e) => {setData({ ...detail, text_en: e.target.value });}} spellCheck="false" style={{width:"680px",minHeight:"380px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                    </>
                    }
                  </Box>
                </Box>
              </Box>
            </Box>
        </Paper>
           )}
          <Box display="flex" justifyContent="right" sx={{margin:"20px"}}>
            <Button variant="contained" color="secondary" sx={{fontWeight:700, margin:"8px 16px"}}
              onClick={() => {
                saveKhmData('N');
              }}
            >
              부적합
            </Button>
            <Button variant="contained" sx={{fontWeight:700, margin:"8px 16px"}}
              onClick={() => {
                saveKhmData('Y');
              }}
            >
              적합
            </Button>
          </Box>
        </Box>
        

        
      </Box></> : "데이터가 없습니다."}
      
    </Paper>
  );
};

export default KhmDetailDialog;
